<input #numSpinnerInput matInput
       (focusout)="focusOut()"
       (keypress)="onKeypress($event)"
       (blur)="onBlur()"
       (ngModelChange)="modelChanged($event)"
       [(ngModel)]="acModel"
       [disabled]="(ngDisabled || (acInputContainerComponent && acInputContainerComponent.isDisabled))?true:null"
       [id]="numSpinnerId?numSpinnerId:null"
       [max]="maxValue | acFunc: limitSpinner"
       [min]="minValue | acFunc: limitSpinner"
       [step]="step"
       [value]="acModel"
       class="ac-num-spinner"
       type="number"/>
